var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "items main-content" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "d-flex flex-row" }, [
        _c("div", [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.$tc("actions.list_of_actions"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c(
          "li",
          { staticClass: "breadcrumb-item" },
          [
            _c(
              "router-link",
              {
                attrs: { slot: "item-title", to: "dashboard" },
                slot: "item-title",
              },
              [_vm._v(_vm._s(_vm.$t("general.home")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "breadcrumb-item" },
          [
            _c(
              "router-link",
              { attrs: { slot: "item-title", to: "#" }, slot: "item-title" },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$tc("actions.list_of_actions"))
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showEmptyScreen,
            expression: "showEmptyScreen",
          },
        ],
        staticClass: "col-xs-1 no-data-info",
        attrs: { align: "center" },
      },
      [
        _c("satellite-icon", { staticClass: "mt-5 mb-4" }),
        _vm._v(" "),
        _c("div", { staticClass: "row", attrs: { align: "center" } }, [
          _c("label", { staticClass: "col title" }, [
            _vm._v(_vm._s(_vm.$t("actions.no_action"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "label",
            { staticClass: "description col mt-1", attrs: { align: "center" } },
            [_vm._v(_vm._s(_vm.$t("actions.list_of_action")))]
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showEmptyScreen,
            expression: "!showEmptyScreen",
          },
        ],
        staticClass: "table-container",
      },
      [
        _c("div", { staticClass: "table-actions mt-5" }, [
          _c("p", { staticClass: "table-stats" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("general.showing")) + ": "),
            _c("b", [_vm._v(_vm._s(_vm.emailActions.length))]),
            _vm._v("\n        " + _vm._s(_vm.$t("general.of")) + " "),
            _c("b", [_vm._v(_vm._s(_vm.totalEmailActions))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "custom-control custom-checkbox" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectAllFieldStatus,
                expression: "selectAllFieldStatus",
              },
            ],
            staticClass: "custom-control-input",
            attrs: { id: "select-all", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.selectAllFieldStatus)
                ? _vm._i(_vm.selectAllFieldStatus, null) > -1
                : _vm.selectAllFieldStatus,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.selectAllFieldStatus,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selectAllFieldStatus = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selectAllFieldStatus = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selectAllFieldStatus = $$c
                  }
                },
                _vm.selectAllEmailActions,
              ],
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isRequestOngoing,
                  expression: "!isRequestOngoing",
                },
              ],
              staticClass: "custom-control-label selectall",
              attrs: { for: "select-all" },
            },
            [
              _c("span", { staticClass: "select-all-label" }, [
                _vm._v(_vm._s(_vm.$t("general.select_all")) + " "),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "table-component",
          {
            ref: "table",
            attrs: {
              data: _vm.fetchData,
              "show-filter": false,
              "table-class": "table",
            },
          },
          [
            _c("table-column", {
              attrs: {
                sortable: false,
                filterable: false,
                "cell-class": "no-click",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (row) {
                    return [
                      _c(
                        "div",
                        { staticClass: "custom-control custom-checkbox" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectField,
                                expression: "selectField",
                              },
                            ],
                            staticClass: "custom-control-input",
                            attrs: { id: row.id, type: "checkbox" },
                            domProps: {
                              value: row.id,
                              checked: Array.isArray(_vm.selectField)
                                ? _vm._i(_vm.selectField, row.id) > -1
                                : _vm.selectField,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectField,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = row.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectField = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectField = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectField = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", {
                            staticClass: "custom-control-label",
                            attrs: { for: row.id },
                          }),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: { label: _vm.$t("actions.name"), show: "name" },
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: {
                label: _vm.$t("actions.updated_at"),
                show: "updated_at",
              },
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: {
                sortable: false,
                filterable: false,
                "cell-class": "action-dropdown",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (row) {
                    return [
                      _c(
                        "v-dropdown",
                        [
                          _c(
                            "a",
                            {
                              attrs: { slot: "activator", href: "#" },
                              slot: "activator",
                            },
                            [_c("dot-icon")],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-dropdown-item",
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "dropdown-item",
                                  attrs: {
                                    to: {
                                      path:
                                        "emailAction/" +
                                        row.id +
                                        "/placeholders",
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "dropdown-item-icon",
                                    attrs: { icon: ["fas", "clone"] },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("actions.placeholders")) +
                                      "\n              "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }